import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../../../components/Button/MenuButton';
import { ReactComponent as ProfileIcon } from '../../../assets/Profile 1.svg';
import { ReactComponent as PasswordIcon } from '../../../assets/PasswordIcon.svg';
import { ReactComponent as HeadphoneIcon } from '../../../assets/Headphone 1.svg';
import LogoutIcon from '../../../assets/Logout.svg';
// import SideBarBgContainer from "../../../components/SideBarBgContainer/SideBarBgContainer";
import {
  ProfileContext,
  ProfileContextProps,
} from '../../../context/ProfileContext';
import { storeTab } from '../../../utils/auth-token-utils/cookie';
import { Typography, Box } from '@mui/material';
import './BabysitterSidebar.css';
import { AuthContext } from '../../../context/AuthContext';

const SmSidebar: React.FC = () => {
  const navigate = useNavigate();

  const { activeTab, handleActiveTab, showLogoutPopup, handleShowLogoutPopup } =
    useContext(ProfileContext) as ProfileContextProps;

  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('Auth Context must be used within a AuthProvider');
  }

  const handleLogout = async () => {
    // handleEmail("");
    // handlePassword("");
    // const response = await logout();
    // const data = await response.data;
    // console.log("data is ", data);
    // if (data.status) {
    //   removeToken();
    //   // removeRole();
    //   removeEmail();
    //   removeStageNumber();
    //   navigate("/signin");
    //   localStorage.setItem("isLoggedOut", Date.now().toString());

    //   console.log("successful");
    // }
    handleShowLogoutPopup(true);
  };

  const handlePasswordSelection = () => {
    handleActiveTab('password');
    storeTab('password');
    navigate('/participant/resetPassword');
  };

  const handleProfile = () => {
    handleActiveTab('profile');
    storeTab('profile');
    navigate('/participant/editprofile');
  };

  const handleSupport = () => {
    handleActiveTab('support');
    storeTab('support');
    navigate('/participant/support');
  };

  return (
    <Box className="sidebar">
      <Box sx={{ marginX: 'auto' }} className="menu-buttons">
        {/*<img src={LeftArrow} onClick={handleBackClick} className="arrow" />*/}
        <Box sx={{ '& > *:not(:last-child)': { mb: 2 } }}>
          <MenuButton
            icon={<ProfileIcon />}
            selected={activeTab === 'profile'}
            onClick={handleProfile}
          >
            Edit Profile
          </MenuButton>
          <MenuButton
            icon={<PasswordIcon />}
            onClick={handlePasswordSelection}
            selected={activeTab === 'password'}
          >
            Change Password
          </MenuButton>

          <MenuButton
            icon={<HeadphoneIcon />}
            onClick={handleSupport}
            selected={activeTab === 'support'}
          >
            Help & Support
          </MenuButton>
        </Box>
      </Box>
      <div className="logout-container-sm" onClick={handleLogout}>
        <div className="logout-icon">
          <img src={LogoutIcon} className="logout-image" alt="Logout" />
        </div>
        <Typography>Logout</Typography>
      </div>
    </Box>
  );
};

export default SmSidebar;
